<template>
  <div>
    {{ ActDescBtn }}
    <table style="position: absolute" width="100%" :height="this.windowSize.height - 8"
      :max-height="this.windowSize.height - 8">
      <tr max-height="48px" height="48px">
        <ContenidoBase :titulo="'Clientes'" :descripcion="'Crear un cliente'" :EstadoBtn="EstadoBtn"
          @abrirBarraTablaDinamica="abrirTabla" @MethodNuevo="newwnuevo" @MethodGuardar="save" @MethodEliminar="remove"
          @MethodAnular="anular" @MethodImprimir="imprimirList" />
      </tr>

      <tr>
        <!-- BarraPrimaria 96 --------------------------------------------------------------------------------->
        <td width="109" :max-height="this.windowSize.height - 96" v-show="BarraTablaDinamicaAprir">
          <!-- style="border:1px solid #000000;" -->
          <div class="overflow-y-auto" v-bind:style="{
            'max-height': this.windowSize.height - 96 + 'px',
            'max-width': '325px',
            width: '325px',
          }">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <!--------------------- aqui va la otra tabla izquierda --------->
                <!-- <v-navigation-drawer >  -->
                <center>
                  <v-btn-toggle>
                    <v-btn small color="yellow accent-4" @click.prevent="actualiza_tb_ver">
                      <i style="font-size: 25px" class="fa fa-eye"></i> ver
                    </v-btn>

                    <v-btn color="teal darken-2" dark text small @click.prevent="
                      (dialogFiltros = true),
                      (ObjTemTbDinam = JSON.parse(
                        JSON.stringify(Modallfiltro)
                      ))
                      ">
                      <i style="font-size: 25px" class="fa fa-search"> </i>
                      Filtrar
                    </v-btn>
                    <v-switch class="mt-0" color="teal" label="" v-model="Modallfiltro.Clseguro" dense
                      @change="CargarListTb">
                      <template v-slot:label>
                        <strong v-if="Modallfiltro.Clseguro == false" style="color:#000000; font-size:12px;">Seguro
                        </strong>
                        <strong v-if="Modallfiltro.Clseguro == true" style="color:#000000; font-size:12px;">Seguro
                        </strong>
                      </template>
                    </v-switch>

                  </v-btn-toggle>
                </center>

                <BarraDinamicaLimitePlus :PropsNombre="'Cliente Agencia'" PropsSearch
                  :PropsSeachNombre="'Búsqueda por nombre'" :TbPaginator="TbPaginator" :TbTotalItem="TbTotalItem"
                  :PropsList="ListItems" @CargarPaginacion="CargarPaginacion" @EmitDAta="datostabla" :headers="[
                    { text: 'Código', value: 'codigo' },
                    /* { text: 'Nombre', value: 'nombre' },
                  { text: 'Balance', value: 'balancecliente.balance' }*/
                  ]" :ContListSlot="[
                    {
                      Text: 'Código',
                      NomValue: 'codigo',
                      Ctsl: 1,
                      Type: 0,
                      State: true,
                    },
                    {
                      Text: 'Nombre',
                      NomValue: 'nombre',
                      Ctsl: 1,
                      Type: 0,
                      State: true,
                    },
                    {
                      Text: 'Balance $',
                      NomValue: 'balancecliente',
                      Nv2: 'balance',
                      Ctsl: 2,
                      Type: 2,
                      State: true,
                    },
                    {
                      Text: 'Estado',
                      NomValue: 'activado',
                      Ctsl: 1,
                      Type: 0.1,
                      State: true,
                    },

                    {
                      Text: 'lista Precio',
                      NomValue: 'listaPrecio',
                      Nv2: 'descripcion',
                      Ctsl: 2,
                      Type: 0,
                      State: true,
                    },
                  ]" />

                <!-- <v-navigation-drawer >  -->
                <!-- <BarraBusqueda2
              :url="$hostname + $hName +'/services/clienteservices/findAllClientesFiltro'"
              :nombre="'Cliente'"
              :headers="headers"
              :slotname="'item.nombre'"
              :emitnombre="'emitCXCClientes2'"
              :SeachNombre="'Búsqueda por el nombre del cliente'"
              :slotlist="slotlist"
              :urlcount="'/services/clienteservices/totalRegistrosCliente'"
            /> -->
                <!-- </v-navigation-drawer> -->
              </template>
            </v-tooltip>
          </div>
        </td>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->

        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height - 96">
          <v-app id="inspire" class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }">

            <!-------------------- Inicio formulario -------------------->
            <v-card class="px-2 grey lighten-3">
              <v-form ref="formCliente" @submit.prevent="" v-model="valid" lazy-validation class="px-2">

                <v-row>

                  <!-------------------- Inicio columna 1 -------------------->
                  <v-col cols="12" sm="6">

                    <v-text-field type="text" label="Código" v-model="cliente.codigo" dense outlined
                      style="font-size: 13px;" readonly>
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px; " class="fa fa-list-ol"></i>
                      </template>
                    </v-text-field>

                    <div class="d-flex align-center mb-3">
                      <span class="text-subtitle-1 font-weight-medium ml-3 mr-3">Información Personal</span>
                      <v-divider></v-divider>
                    </div>

                    <v-text-field type="text" label="Nombre *" dense outlined style="font-size: 13px;"
                      v-model="cliente.nombre" :rules="[rules.required]">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px; " class="fa fa-font"></i>
                      </template>
                    </v-text-field>

                    <v-text-field type="text" label="Cedula/RNC *" v-model="cliente.cedrnc" dense outlined
                      style="font-size: 13px;" :rules="[$rules.RulesCelRncValidar]" v-mask="'###-#######-#'">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px; " class="fa fa-id-card-o"></i>
                      </template>
                    </v-text-field>

                    <v-textarea type="text" label="Direccion *" v-model="cliente.direccion" autocomplete="off" dense
                      outlined style="font-size: 13px;" :rules="[rules.required]">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px;" class="fa fa-map-marker"></i>
                      </template>
                    </v-textarea>

                    <v-autocomplete label="País *" dense outlined style="font-size: 13px;" @focus="findAllPaises"
                      v-model="cliente.pais" :items="paisesList" item-text="nombre" return-object
                      :rules="[rules.required]">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px; " class="fa fa-globe"></i>
                      </template>
                    </v-autocomplete>

                    <v-text-field type="text" label="Ciudad *" v-model="cliente.ciudad" dense outlined
                      style="font-size: 13px;" :rules="[rules.required]">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px; " class="fa fa-map"></i>
                      </template>
                    </v-text-field>

                    <v-text-field type="text" label="Paraje" v-model="cliente.paraje" dense outlined
                      style="font-size: 13px;">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px;" class="fa fa-map-marker"></i>
                      </template>
                    </v-text-field>

                    <v-text-field type="text" label="Cerca de" v-model="cliente.cercade" dense outlined
                      style="font-size: 13px;">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px; " class="fa fa-map"></i>
                      </template>
                    </v-text-field>

                    <v-text-field type="text" label="Otra ubicacion" v-model="cliente.otraubicacion" dense outlined
                      style="font-size: 13px;">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px; " class="fa fa-map"></i>
                      </template>
                    </v-text-field>

                    <div class="d-flex align-center mb-3">
                      <span class="text-subtitle-1 font-weight-medium ml-3 mr-3">Información de Trabajo</span>
                      <v-divider></v-divider>
                    </div>

                    <v-text-field type="text" label="Donde trabaja" v-model="cliente.dondetrabaja" dense outlined
                      style="font-size: 13px;">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px; " class="fa fa-briefcase"></i>
                      </template>
                    </v-text-field>

                    <v-text-field type="text" label="Que trabaja" v-model="cliente.quetrabaja" dense outlined
                      style="font-size: 13px;">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px; " class="fa fa-briefcase"></i>
                      </template>
                    </v-text-field>

                    <v-text-field type="text" label="Ref. Comercial #1" v-model="cliente.referenciacomercial" dense
                      outlined style="font-size: 13px;">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px; " class="fa fa-certificate"></i>
                      </template>
                    </v-text-field>

                    <v-text-field type="text" label="Ref. Comercial #2" v-model="cliente.referenciacomercial2" dense
                      outlined style="font-size: 13px;">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px; " class="fa fa-certificate"></i>
                      </template>
                    </v-text-field>

                    <v-text-field type="text" label="Ref. Personal #1" v-model="cliente.referenciapersonal" dense
                      outlined style="font-size: 13px;">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px; " class="fa fa-user-circle"></i>
                      </template>
                    </v-text-field>

                    <v-text-field type="text" label="Ref. Personal #2" v-model="cliente.referenciapersonal2" dense
                      outlined style="font-size: 13px;">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px; " class="fa fa-user-circle"></i>
                      </template>
                    </v-text-field>

                  </v-col>
                  <!-------------------- Fin columna 1 -------------------->

                  <!-------------------- Inicio columna 2 -------------------->
                  <v-col cols="12" sm="6">

                    <div class="d-flex align-center mb-3">
                      <span class="text-subtitle-1 font-weight-medium ml-3 mr-3">Información de Contacto</span>
                      <v-divider></v-divider>
                    </div>

                    <v-text-field type="text" label="Teléfono de Contacto" v-model="cliente.telefonocontacto" dense
                      outlined style="font-size: 13px;" v-mask="'(###)###-####'" maxlength="13">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px; " class="fa fa-phone"></i>
                      </template>
                    </v-text-field>

                    <v-row style="padding-left: 12px;">
                      <v-text-field type="text" label="Teléfono extra" dense outlined style="font-size: 13px;"
                        v-model="nuevoTelefono.telefonosClientesPK.telefono" v-mask="'(###)###-####'">
                        <template v-slot:prepend>
                          <i style="font-size: 20px; width: 20px;" class="fa fa-phone"></i>
                        </template>
                      </v-text-field>

                      <v-btn small color="green" class="inline-btn" @click="addTelefono">
                        <i style="font-size: 20px; width: 20px; color: white;" class="fa fa-plus"></i>
                      </v-btn>
                    </v-row>

                    <v-card outlined class="mt-2 mx-3 mb-3" v-if="cliente.telefonosClientesList.length > 0">
                      <v-list dense>
                        <v-subheader>Teléfonos registrados</v-subheader>

                        <v-list-item v-for="(telefono, index) in cliente.telefonosClientesList" :key="index">
                          <v-list-item-icon>
                            <i class="fa fa-phone" style="font-size: 16px;"></i>
                          </v-list-item-icon>

                          <v-list-item-content>
                            <v-list-item-title>{{ telefono.telefonosClientesPK.telefono }}</v-list-item-title>
                          </v-list-item-content>

                          <v-list-item-action>
                            <v-btn icon x-small color="error" @click="deleteTelefono(index)">
                              <i class="fa fa-trash"></i>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-card>

                    <v-text-field type="email" label="Email" v-model="cliente.email" dense outlined
                      style="font-size: 13px;">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px; " class="fa fa-envelope-o"></i>
                      </template>
                    </v-text-field>

                    <v-text-field type="date" label="Fecha de Nacimiento" v-model="cliente.fechanacimiento" dense
                      outlined style="font-size: 13px;">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px; " class="fa fa-calendar"></i>
                      </template>
                    </v-text-field>

                    <v-text-field type="date" label="Fecha de Ingreso" v-model="cliente.fechaingreso" dense outlined
                      style="font-size: 13px;">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px; " class="fa fa-calendar"></i>
                      </template>
                    </v-text-field>

                    <div class="d-flex align-center mb-3">
                      <span class="text-subtitle-1 font-weight-medium ml-3 mr-3">Información Contable</span>
                      <v-divider></v-divider>
                    </div>

                    <v-text-field type="number" min="0" label="Días de Crédito" v-model="cliente.diascredito" dense
                      outlined style="font-size: 13px;" @focus="$event.target.select()">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px; " class="fa fa-credit-card"></i>
                      </template>
                    </v-text-field>

                    <!-- ----------------------------- Límite de Crédito -->
                    <VueAutonumeric label="Límite de Crédito:" dense outlined autocomplete="off"
                      v-model.number="cliente.limitecredito" style="font-size: 13px;">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px;" class="fa fa-usd"></i>
                      </template>
                    </VueAutonumeric>


                    <v-autocomplete type="text" label="Tipo de Cliente *" v-model="cliente.tipocliente" dense outlined
                      style="font-size: 13px;" @focus="findAllTipoCliente" :items="clienteTipoList"
                      item-text="descripcion" return-object :rules="[rules.required]">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px; " class="fa fa-user"></i>
                      </template>
                    </v-autocomplete>

                    <v-autocomplete label="Vendedor" v-model="cliente.vendedor" dense outlined clearable
                      style="font-size: 13px;" @focus="findVendedores('')" @keyup="findVendedores($event.target.value)" :items="vendedorList"
                      item-text="nombre" item-value="codigo">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px; " class="fa fa-usd"></i>
                      </template>
                    </v-autocomplete>

                    <v-text-field label="Zona" v-model="cliente.zona" dense outlined style="font-size: 13px;">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px; " class="fa fa-usd"></i>
                      </template>
                    </v-text-field>

                    <v-text-field label="Tipo" v-model="cliente.tipo" dense outlined style="font-size: 13px;">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px; " class="fa fa-usd"></i>
                      </template>
                    </v-text-field>

                    <v-autocomplete label="Tipo de Comprobante *" v-model="cliente.tipocomprobante" dense outlined
                      style="font-size: 13px;" @focus="findAllComprobantes" :items="comprobanteList"
                      item-text="descripcion" return-object :rules="[rules.required]">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px; " class="fa fa-book"></i>
                      </template>
                    </v-autocomplete>

                    <v-checkbox label="Activo" v-model="cliente.activado" dense outlined style="font-size: 13px;">
                    </v-checkbox>

                    <v-text-field type="text" label="Aviso/Alerta" v-model="cliente.avisoalerta" dense outlined
                      style="font-size: 13px;">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px; " class="fa fa-exclamation-circle"></i>
                      </template>
                    </v-text-field>

                    <v-textarea type="text" label="Comentario" v-model="cliente.comentario" dense outlined
                      style="font-size: 13px;">
                      <template v-slot:prepend>
                        <i style="font-size: 20px; width: 20px; " class="fa fa-comment"></i>
                      </template>
                    </v-textarea>


                  </v-col>
                  <!-------------------- Fin columna 2 -------------------->

                  <!-------------------- Inicio pasaportes -------------------->
                  <v-row>
                    <v-col cols="12">
                      <v-card elevation="2">
                        <v-card-title class="primary lighten-1 white--text">
                          <v-icon large left color="white">fa fa-passport</v-icon>
                          Pasaportes
                          <v-spacer></v-spacer>
                          <v-btn color="white" text @click="abrirDialogPasaporte()">
                            <v-icon left>fa fa-plus</v-icon>
                            Añadir Pasaporte
                          </v-btn>
                        </v-card-title>

                        <!-- Lista de pasaportes existentes -->
                        <v-card-text v-if="pasaporteList.length > 0">
                          <v-data-table :headers="pasaporteListHeaders" :items="pasaporteList" :items-per-page="5"
                            class="elevation-1" dense>

                            <template v-slot:item.fechaemision="{ item }">
                              {{ item.fechaemision }}
                            </template>

                            <template v-slot:item.fechavencimiento="{ item }">
                              {{ item.fechavencimiento }}
                            </template>

                            <template v-slot:item.acciones="{ item, index }">
                              <v-btn icon small color="primary" class="mr-1" @click="editarPasaporte(item, index)">
                                <i class="fa fa-edit"></i>
                              </v-btn>
                              <v-btn icon small color="error" @click="confirmarEliminarPasaporte(item)">
                                <i class="fa fa-trash"></i>
                              </v-btn>
                            </template>
                          </v-data-table>
                        </v-card-text>

                        <!-- Mensaje cuando no hay pasaportes -->
                        <v-card-text v-else class="text-center pa-5">
                          <v-icon size="64" color="grey lighten-1">fa fa-passport</v-icon>
                          <p class="grey--text text--darken-1 mt-3">
                            No hay pasaportes registrados. Haga clic en "Añadir Pasaporte" para registrar uno nuevo.
                          </p>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <!-- Diálogo para agregar/editar pasaporte -->
                    <v-dialog v-model="dialogPasaporte" max-width="800px">
                      <v-card>
                        <v-card-title class="primary lighten-1 white--text">
                          {{ modoEdicion ? 'Editar Pasaporte' : 'Nuevo Pasaporte' }}
                          <v-spacer></v-spacer>
                          <v-btn icon dark @click="dialogPasaporte = false">
                            <v-icon>fa fa-times</v-icon>
                          </v-btn>
                        </v-card-title>

                        <v-card-text>
                          <v-container>
                            <v-form ref="formPasaporte">

                              <v-row dense>
                                <v-col cols="12" md="6">

                                  <!-- Número de pasaporte -->
                                  <v-text-field v-model="pasaporte.numeropasaporte" label="Número de Pasaporte *" dense
                                    outlined :rules="[rules.required]">
                                    <template v-slot:prepend>
                                      <i class="fa fa-id-card" style="font-size: 18px; width: 20px;"></i>
                                    </template>
                                  </v-text-field>

                                  <!-- Nombre completo -->
                                  <v-text-field v-model="pasaporte.nombre" label="Nombre Completo *" dense outlined
                                    :rules="[rules.required]">
                                    <template v-slot:prepend>
                                      <i class="fa fa-user" style="font-size: 18px; width: 20px;"></i>
                                    </template>
                                  </v-text-field>

                                  <!-- Nacionalidad -->
                                  <v-autocomplete v-model="pasaporte.nacionalidad" :items="nacionalidadList"
                                    @focus="findAllNacionalidades" item-text="descripcion" item-value="descripcion"
                                    label="Nacionalidad" dense outlined>
                                    <template v-slot:prepend>
                                      <i class="fa fa-flag" style="font-size: 18px; width: 20px;"></i>
                                    </template>
                                  </v-autocomplete>

                                  <v-row dense>
                                    <!-- Fecha de emisión -->
                                    <v-text-field type="date" v-model="pasaporte.fechaemision" label="Fecha de Emision"
                                      dense outlined :rules="[rules.fechaEmisionLessThanFechaVencimiento]">
                                      <template v-slot:prepend>
                                        <i class="fa fa-calendar" style="font-size: 18px; width: 20px;"></i>
                                      </template>
                                    </v-text-field>

                                    <!-- Fecha de vencimiento -->
                                    <v-text-field type="date" v-model="pasaporte.fechavencimiento"
                                      label="Fecha de Vencimiento" dense outlined
                                      :rules="[rules.fechaEmisionLessThanFechaVencimiento]">
                                    </v-text-field>
                                  </v-row>

                                </v-col>

                                <v-col cols="12" md="6">

                                  <!-- Tipo de pasaporte -->
                                  <v-autocomplete v-model="pasaporte.tipopasaporte" :items="tiposPasaporte"
                                    label="Tipo de Pasaporte *" dense outlined :rules="[rules.required]">
                                    <template v-slot:prepend>
                                      <i class="fa fa-list" style="font-size: 18px; width: 20px;"></i>
                                    </template>
                                  </v-autocomplete>

                                  <!-- Estado civil -->
                                  <v-autocomplete v-model="pasaporte.estadocivil" :items="estadosCiviles"
                                    label="Estado Civil" dense outlined>
                                    <template v-slot:prepend>
                                      <i class="fa fa-heart" style="font-size: 18px; width: 20px;"></i>
                                    </template>
                                  </v-autocomplete>

                                  <!-- Lugar de nacimiento -->
                                  <v-text-field v-model="pasaporte.lugarnacimiento" label="Lugar de Nacimiento" dense
                                    outlined>
                                    <template v-slot:prepend>
                                      <i style="font-size: 18px; width: 20px; " class="fa fa-map"></i>
                                    </template>
                                  </v-text-field>

                                  <!-- Ocupación -->
                                  <v-text-field v-model="pasaporte.ocupacion" label="Ocupación" dense outlined>
                                    <template v-slot:prepend>
                                      <i class="fa fa-briefcase" style="font-size: 18px; width: 20px;"></i>
                                    </template>
                                  </v-text-field>

                                </v-col>

                                <!-- Dirección exterior -->
                                <v-col cols="12">
                                  <v-text-field v-model="pasaporte.direccionexterior" label="Dirección en el Exterior"
                                    dense outlined>
                                    <template v-slot:prepend>
                                      <i class="fa fa-home" style="font-size: 18px; width: 20px;"></i>
                                    </template>
                                  </v-text-field>
                                </v-col>

                                <!-- Teléfono exterior -->
                                <v-col cols="12" sm="6">
                                  <v-text-field v-model="pasaporte.numerotelefonoexterior"
                                    label="Teléfono en el Exterior" dense outlined v-mask="'(###)###-####'">
                                    <template v-slot:prepend>
                                      <i class="fa fa-phone" style="font-size: 18px; width: 20px;"></i>
                                    </template>
                                  </v-text-field>
                                </v-col>

                                <!-- Parentesco -->
                                <v-col cols="12" sm="6">
                                  <v-text-field v-model="pasaporte.parentesco" label="Parentesco" dense outlined>
                                    <template v-slot:prepend>
                                      <i class="fa fa-users" style="font-size: 18px; width: 20px;"></i>
                                    </template>
                                  </v-text-field>
                                </v-col>

                                <v-row justify="center" v-if="pasaporteVencido">
                                  <h1 style="color: red;">Pasaporte vencido</h1>
                                </v-row>
                              </v-row>

                            </v-form>
                          </v-container>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="grey darken-1" text @click="dialogPasaporte = false">
                            Cancelar
                          </v-btn>
                          <v-btn color="primary" @click="addPasaporte" :loading="enEjecucion">
                            {{ modoEdicion ? 'Actualizar' : 'Guardar' }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>

                    <!-- Diálogo de confirmación para eliminar -->
                    <v-dialog v-model="dialogConfirmacion" max-width="400">
                      <v-card>
                        <v-card-title class="headline error--text">
                          ¿Eliminar pasaporte?
                        </v-card-title>
                        <v-card-text>
                          Esta acción no se puede deshacer. ¿Está seguro que desea eliminar este pasaporte?
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="grey darken-1" text @click="dialogConfirmacion = false">
                            Cancelar
                          </v-btn>
                          <v-btn color="error" @click="deletePasaporte">
                            Eliminar
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-row>

                  <!-------------------- Fin pasaportes -------------------->

                </v-row>
              </v-form>

            </v-card>
            <!-------------------- Fin formulario -------------------->
          </v-app>

        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
        <!-- ------------------------------------------------------ tb-data todo general -->
        <v-dialog label="myAlert" v-model="acti_tb_data" persistent transition="dialog-bottom-transition" fullscreen
          hide-overlay>
          <v-card>
            <v-toolbar dense flat color="#BDBDBD">
              <i style="font-size: 20px" class="fa fa-file-pdf-o"></i>
              <v-toolbar-title class="font-weight-light">REPORTE</v-toolbar-title>
              <i style="font-size: 20px" class="fa fa-file-pdf-o"></i>

              <v-spacer></v-spacer>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" dark small color="deep-purple accent-2" @click.prevent="
                    (dialogimprimirListFilt = true),
                    (datosImprecion.secuencia = 0)
                    ">
                    <i style="font-size: 25px" class="fa fa-print"> </i>
                    Listado
                  </v-btn>
                </template>
                <span>Imprimir Listado</span>
              </v-tooltip>
              <v-btn color="grey darken-4" fab small @click="actualiza_tb_ver">
                <i style="font-size: 20px; color: #dd4b39" class="fa fa-close"></i>
              </v-btn>
            </v-toolbar>

            <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
              <v-card>
                <v-card-title>
                  <v-text-field v-model="Modallfiltro.cliente" @keyup="CargarListTb" label="Search" single-line
                    hide-details>
                    <template v-slot:prepend-inner>
                      <i style="font-size: 35px" class="fa fa-search"></i>
                    </template>
                  </v-text-field>
                </v-card-title>

                <v-data-table class="TbSize13" :headers="[
                  {
                    text: 'Código',
                    sortable: false,
                    value: 'codigo',
                    class: ['black--text'],
                  },
                  {
                    text: 'Nombre',
                    sortable: false,
                    value: 'nombre',
                    width: 250,
                    class: ['no-gutters black--text'],
                  },
                  {
                    text: 'Cedula/Rnc:',
                    sortable: false,
                    value: 'cedrnc',
                    width: 130,
                    class: ['no-gutters black--text'],
                  },
                  {
                    text: 'Fec.nacimiento',
                    sortable: false,
                    value: 'fechanacimiento',
                    width: 150,
                    class: ['no-gutters black--text'],
                  },
                  {
                    text: 'Email:',
                    sortable: false,
                    value: 'email',
                    width: 120,
                    class: ['no-gutters black--text'],
                  },
                  {
                    text: 'Ciudad',
                    sortable: false,
                    value: 'ciudad',
                    width: 150,
                    class: ['no-gutters black--text'],
                  },
                  {
                    text: 'Dirección',
                    sortable: false,
                    value: 'direccion',
                    width: 250,
                    class: ['no-gutters black--text'],
                  },
                  // { text: 'pais', sortable: false,  value: 'pais.nombre', width: 150 },
                  {
                    text: 'Cerca de:',
                    sortable: false,
                    value: 'cercade',
                    width: 250,
                    class: ['no-gutters black--text'],
                  },
                  {
                    text: 'Paraje:',
                    sortable: false,
                    value: 'paraje',
                    width: 250,
                    class: ['no-gutters black--text'],
                  },
                  {
                    text: 'Otra Ubicación:',
                    sortable: false,
                    value: 'otraubicacion',
                    width: 250,
                    class: ['no-gutters black--text'],
                  },
                  {
                    text: 'Donde Trabaja:',
                    sortable: false,
                    value: 'dondetrabaja',
                    width: 120,
                    class: ['no-gutters black--text'],
                  },
                  {
                    text: 'Ref. Comercial #1:',
                    sortable: false,
                    value: 'referenciacomercial',
                    width: 250,
                    class: ['no-gutters black--text'],
                  },
                  {
                    text: 'Ref. Comercial #2:',
                    sortable: false,
                    value: 'referenciacomercial2',
                    width: 250,
                    class: ['no-gutters black--text'],
                  },
                  {
                    text: 'Ref. Personal #1:',
                    sortable: false,
                    value: 'referenciapersonal',
                    width: 250,
                    class: ['no-gutters black--text'],
                  },
                  {
                    text: 'Ref. Personal #2:',
                    sortable: false,
                    value: 'referenciapersonal2',
                    width: 250,
                    class: ['no-gutters black--text'],
                  },
                  {
                    text: 'Aviso/Alerta',
                    sortable: false,
                    value: 'avisoalerta',
                    width: 120,
                    class: ['no-gutters black--text'],
                  },
                  {
                    text: 'Comentario',
                    sortable: false,
                    value: 'comentario',
                    width: 250,
                    class: ['no-gutters black--text'],
                  },
                  {
                    text: 'Fecha Ingreso',
                    sortable: false,
                    value: 'fechaingreso',
                    width: 150,
                    class: ['no-gutters black--text'],
                  },
                  {
                    text: 'Días de Crédito',
                    sortable: false,
                    value: 'diascredito',
                    width: 120,
                    class: ['no-gutters black--text'],
                  },
                  {
                    text: 'Lím.Crédito',
                    sortable: false,
                    value: 'limitecredito',
                    width: 120,
                    class: ['no-gutters black--text'],
                  },
                  {
                    text: 'Tipo de Cliente',
                    sortable: false,
                    value: 'tipocliente.descripcion',
                    width: 120,
                    class: ['no-gutters black--text'],
                  },
                  {
                    text: 'vendedores',
                    sortable: false,
                    value: 'vendedores.nombre',
                    width: 120,
                    class: ['no-gutters black--text'],
                  },
                  {
                    text: 'Zona',
                    sortable: false,
                    value: 'zona',
                    width: 120,
                    class: ['no-gutters black--text'],
                  },
                  {
                    text: 'tipo',
                    sortable: false,
                    value: 'tipo',
                    width: 120,
                    class: ['no-gutters black--text'],
                  },
                  {
                    text: 'Estatus',
                    sortable: false,
                    value: 'statuscliente',
                    width: 120,
                    class: ['no-gutters black--text'],
                  },
                  {
                    text: 'Activo',
                    sortable: false,
                    value: 'activado',
                    width: 120,
                    class: ['no-gutters black--text'],
                  },
                ]" dense @pagination="cargarPaginacionAll" :items-per-page="TbPaginator.itemsPerPage"
                  :page="TbPaginator.page" :pageCount="TbPaginator.pageCount" :items="ListItems"
                  :search="Modallfiltro.cliente" @click:row="datostabla" :server-items-length="TbTotalItem">
                  <template v-slot:item.activado="props">
                    <span v-if="props.item.activado == true" style="font-size: 13px">Activo</span>
                    <span v-if="props.item.activado == false" style="font-size: 13px">In-Activo</span>
                  </template>

                  <template v-slot:item.fechanacimiento="props">
                    <span style="font-size: 13px">{{
                      fecFormatter(props.item.fechanacimiento)
                      }}</span>
                  </template>

                  <!-- <template v-slot:item.nombre="props">
                        <span style="font-size:13px;" >{{props.item.nombre}}</span>
                      </template> -->
                </v-data-table>
              </v-card>
            </v-col>
          </v-card>
        </v-dialog>
        <!-- ------------------------------------------------------ fn tb-data todo general -->
        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td width="109" :max-height="this.windowSize.height - 96" v-show="BarraSecundariaAprir">
          <div class="overflow-y-auto" v-bind:style="{
            'max-height': this.windowSize.height - 96 + 'px',
            'max-width': '325px',
            width: '325px',
          }"></div>
        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->
        <!-- Alerta ------------------------------------------------------------------------------------------>
        <v-snackbar v-model="alerta.estado" :color="alerta.color" :vertical="true" :timeout="alerta.time" absolute>
          {{ alerta.message }}
          <v-btn dark text @click="alerta.estado = false">Close</v-btn>
        </v-snackbar>
        <!-- fn Alerta ------------------------------------------------------------------------------------------>
        <!-- Indicador de ejecucion ------------------------------------------------------------------------------------------>
        <div v-if="enEjecucion" class="form-loading-indicator">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <!-- fn Indicador de ejecucion ------------------------------------------------------------------------------------------>
      </tr>
    </table>
  </div>
</template>

<script>

import VueAutonumeric from "../../components/AutoNumericNuevo";
import { EventBus } from "../../event-bus";
import ContenidoBase from "../../components/ContenidoBase";
import BarraDinamicaLimitePlus from "../../components/BarraDinamicaLimitePlus";
import ModalReporteFiltros from "../../components/ModalReporteFiltros2";
import ModalReporteBasico from "../../components/ModalReporteBasico2";

export default {
  components: {
    VueAutonumeric,
    ContenidoBase,
    BarraDinamicaLimitePlus,
    ModalReporteFiltros,
    ModalReporteBasico,
  },

  created() {
    var json = {
      titulo: "Precio Producto",
      descripcion: "Ver Precio de los Productos",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      btnBarraDi: false,
    };
    EventBus.$emit("anularBotonesAccion", json);
  },

  mounted() {
  },

  methods: {
    editarPasaporte(item, index) {
      this.modoEdicion = true
      this.pasaporte = item
      this.pasaporte.index = index
      this.dialogPasaporte = true;
    },

    deletePasaporte() {
      this.pasaporteList.pop(this.pasaporteToDelete)
      this.dialogConfirmacion = false;
    },

    confirmarEliminarPasaporte(item) {
      this.pasaporteToDelete = { ...item };
      this.dialogConfirmacion = true;
    },

    addPasaporte() {
      if (this.$refs.formPasaporte.validate()) {
        this.pasaporte.cliente = this.cliente
        this.pasaporte.borrado = false
        if (!this.modoEdicion) {
          this.pasaporteList.push(this.pasaporte)
        } else {
          this.pasaporteList[this.pasaporte.index] = this.pasaporte
        }
        this.dialogPasaporte = false
        this.showAlert("Pasaporte salvado correctamente", "success", 4000)
      } else {
        this.showAlert("Pasaporte invalido", "error", 4000)
      }
    },

    abrirDialogPasaporte() {
      this.modoEdicion = false;
      this.pasaporte = {
        codigo: 0,
        numeropasaporte: "",
        fechaemision: null,
        fechavencimiento: null,
        estadocivil: "",
        lugarnacimiento: "",
        nacionalidad: "",
        direccionexterior: "",
        numerotelefonoexterior: "",
        parentesco: "",
        nombre: "",
        ocupacion: "",
        tipopasaporte: "",
      };
      this.dialogPasaporte = true;
    },

    findVendedores(val) {
      this.$axios
        .get(this.$hostname + this.$hName + "/vendedores/findAllByNombre", {
          params: {
            nombre: val,
            page: 0,
            size: 25, //pageSize
          }
        })
        .then((res) => {
          this.vendedorList = res.data.content
        });
    },

    findAllComprobantes() {
      this.$axios
        .get(this.$hostname + this.$hName + "/tiponcf/findall")
        .then((res) => {
          this.comprobanteList = res.data
        });
    },

    findAllTipoCliente() {
      this.$axios
        .get(this.$hostname + this.$hName + "/tipoclientes/findallActivo")
        .then((res) => {
          this.clienteTipoList = res.data
        });
    },

    findAllPaises() {
      this.$axios
        .get(this.$hostname + this.$hName + "/paises/findall")
        .then((res) => {
          this.paisesList = res.data
        });
    },

    findAllNacionalidades() {
      this.$axios
        .get(this.$hostname + this.$hName + "/paises/nacionalidades")
        .then((res) => {
          this.nacionalidadList = res.data
        });
    },

    addTelefono() {
      if (this.nuevoTelefono.telefonosClientesPK.telefono.trim() !== '') {
        this.cliente.telefonosClientesList.push(this.nuevoTelefono);
        this.nuevoTelefono = {
          "telefonosClientesPK": {
            "telefono": "",
          },
          "activo": true,
          "borrado": false,
        }
      };
    },

    deleteTelefono(index) {
      this.cliente.telefonosClientesList.splice(index, 1);
    },

    // Metodos previos
    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data;
      this.Limpiarfiltro();
    },

    CargarPaginacion(e, s) {
      this.Modallfiltro.cliente = JSON.parse(JSON.stringify(s));

      if (e.itemsPerPage == -1) {
        e.itemsPerPage = 15;
      }
      //var pg =
      this.TbPaginator = JSON.parse(JSON.stringify(e));
      this.CargarListTb();
    },

    datostabla(e) {
      this.newwnuevo();
      var _this = this;
      setTimeout(function () {
        _this.datostabla2(e);
      }, 500);
    },

    datostabla2(e) {
      this.findAllComprobantes()
      this.findAllPaises()
      this.findAllTipoCliente()
      this.acti_tb_data = false
      this.cliente.cedrnc = e.cedrnc

      this.cliente = {
        codigo: e.codigo,
        nombre: e.nombre,
        cedrnc: e.cedrnc,
        direccion: e.direccion,
        pais: e.pais,
        ciudad: e.ciudad,
        paraje: e.paraje,
        cercade: e.cercade,
        otraubicacion: e.otraubicacion,

        dondetrabaja: e.dondetrabaja,
        quetrabaja: e.quetrabaja,
        referenciacomercial: e.referenciacomercial,
        referenciacomercial2: e.referenciacomercial2,
        referenciapersonal: e.referenciapersonal,
        referenciapersonal2: e.referenciapersonal2,

        telefonocontacto: e.telefonocontacto,
        email: e.email,
        fechanacimiento: e.fechanacimiento,
        fechaingreso: e.fechaingreso,

        diascredito: e.diascredito,
        limitecredito: e.limitecredito,
        tipocliente: e.tipocliente,
        vendedor: e.vendedor,
        zona: e.zona,
        tipo: e.tipo,
        tipocomprobante: e.tipocomprobante,
        avisoalerta: e.avisoalerta,
        comentario: e.comentario,

        pasaporteList: [],
        telefonosClientesList: e.telefonosClientesList,
        asArs: e.asArs,
        activado: e.activado,
        borrado: e.borrado,
      }
      this.findPasaportesClienteById(this.cliente.codigo)
    },

    findPasaportesClienteById(clienteId) {
      this.$axios
        .get(this.$hostname + this.$hName + "/clientes/pasaportes/" + clienteId)
        .then((res) => {
          this.pasaporteList = res.data
        })
        .catch((error) => {
          console.log("Error al buscar pasaporte", error);
          this.showAlert('Error al buscar pasaporte', 'error', 4000);
        });

    },

    cargarPaginacionAll(e) {
      if (e.itemsPerPage == -1) {
        e.itemsPerPage = 15;
      }
      this.CargarPaginacion(e, this.Modallfiltro.cliente);
    },

    fecFormatter(params) {
      if (params != null) {
        if (params.length > 0) {
          return (
            params.substring(8, 10) +
            "-" +
            params.substring(5, 7) +
            "-" +
            params.substring(0, 4)
          );
        }
      }
    },


    CargarListTb() {
      var tipo = null;
      if (this.Modallfiltro.tipocliente != null) {
        tipo = this.Modallfiltro.tipocliente.codigo;
      }
      var obj =
        this.TbPaginator.itemsPerPage +
        "/" +
        this.TbPaginator.pageStart +
        "/" +
        this.Modallfiltro.cliente +
        "/" +
        tipo +
        "/" +
        this.Modallfiltro.Clseguro +
        "/" +
        this.Modallfiltro.activos +
        "/" +
        this.Modallfiltro.opcion;

      this.$axios
        .get(
          this.$hostname + this.$hName + "/clientes/findListClientePlus/" + obj,
          { headers: this.$store.getters.GetheadersAxios }
        )
        .then((res) => {
          (this.ListItems = res.data.ListCliente),
            (this.TbTotalItem = res.data.TbTotalItem);
        });
    },

    Limpiarfiltro() {
      var Pg = {
        itemsLength: this.TbPaginator.itemsLength,
        itemsPerPage: this.TbPaginator.itemsPerPage,
        page: 1,
        pageCount: 1,
        pageStart: 0,
        pageStop: this.TbPaginator.itemsPerPage,
      };

      this.Modallfiltro = {
        Clseguro: false,
        activos: true,
        cliente: null,
        tipocliente: null,
        opcion: 1
      };

      this.ListItems = [];
      this.TbTotalItem = 0;

      this.TbPaginator = JSON.parse(JSON.stringify(Pg));
      this.CargarListTb();
      this.dialogFiltros = false;
    },

    // Guardar objeto
    save() {
      if (this.$refs.formCliente.validate()) {
        this.enEjecucion = true;
        this.cliente.asArs = false

        // Primera petición: guardar cliente
        this.$axios
          .post(this.$hostname + this.$hName + "/clientes/save", this.cliente)
          .then((res) => {
            this.cliente = res.data;

            // Segunda petición: guardar pasaportes
            return this.$axios.post(
              this.$hostname + this.$hName + "/clientes/pasaportes", this.pasaporteList,
              {
                params: {
                  clienteId: this.cliente.codigo
                }
              }
            );
          })
          .then((res) => {
            this.limpiarForm();
            this.CargarListTb();
            this.showAlert("Salvado exitoso", 'success', 4000);
          })
          .catch((error) => {
            this.enEjecucion = false;
            console.log("Error al salvar", error);
            this.showAlert('Error al salvar el cliente', 'error', 4000);
          });
      } else {
        this.showAlert('Cliente inválido', 'error', 4000);
        console.log("Error salvando");
      }
    },

    // Limpiar formulario
    limpiarForm() {
      this.cliente = {
        codigo: 0,
        nombre: "",
        cedrnc: "",
        direccion: "",
        pais: null,
        ciudad: null,
        paraje: "",
        cercade: "",
        otraubicacion: "",

        dondetrabaja: "",
        quetrabaja: "",
        referenciacomercial: "",
        referenciacomercial2: "",
        referenciapersonal: "",
        referenciapersonal2: "",

        telefonocontacto: "",
        email: "",
        fechanacimiento: null,
        fechaingreso: null,

        diascredito: 0,
        limitecredito: 0,
        tipocliente: "",
        vendedor: 0,
        zona: "",
        tipo: "",
        tipocomprobante: null,
        avisoalerta: "",
        comentario: "",

        pasaporteList: [],
        telefonosClientesList: [],
        activado: true,
        borrado: false
      }

      this.pasaporte = {
        index: 0,
        codigo: "",
        numeropasaporte: "",
        fechaemision: null,
        fechavencimiento: null,
        estadocivil: "",
        lugarnacimiento: "",
        nacionalidad: "",
        direccionexterior: "",
        numerotelefonoexterior: "",
        parentesco: "",
        nombre: "",
        ocupacion: "",
        tipopasaporte: "",
        borrado: false,
      }

      this.pasaporteList = []

      this.enEjecucion = false
      this.$refs.formCliente.resetValidation()
    },

    remove() { },
    anular() { },
    imprimir() { },
    nuevo() { },
    newwnuevo() {
      this.limpiarForm()
    },
    imprimirList() { },

    showAlert(message, type, time) {
      this.alerta.message = message;
      this.alerta.color = type;
      this.alerta.time = time
      this.alerta.estado = true;
    },

    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir;
    },
  },

  data() {
    return {

      // Data de objetos
      cliente: {
        codigo: 0,
        nombre: "",
        cedrnc: "",
        direccion: "",
        pais: null,
        ciudad: null,
        paraje: "",
        cercade: "",
        otraubicacion: "",

        dondetrabaja: "",
        quetrabaja: "",
        referenciacomercial: "",
        referenciacomercial2: "",
        referenciapersonal: "",
        referenciapersonal2: "",

        telefonocontacto: "",
        email: "",
        fechanacimiento: null,
        fechaingreso: null,

        diascredito: 0,
        limitecredito: 0,
        vendedor: 0,
        zona: "",
        tipo: "",
        tipocomprobante: null,
        avisoalerta: "",
        comentario: "",

        telefonosClientesList: [],

        asArs: false,
        activado: true,
        borrado: false,
      },

      pasaporte: {
        index: 0,
        codigo: "",
        numeropasaporte: "",
        fechaemision: null,
        fechavencimiento: null,
        estadocivil: "",
        lugarnacimiento: "",
        nacionalidad: "",
        direccionexterior: "",
        numerotelefonoexterior: "",
        parentesco: "",
        nombre: "",
        ocupacion: "",
        tipopasaporte: "",
      },

      pasaporteList: [],
      pasaporteToDelete: "",
      dialogPasaporte: false,
      dialogConfirmacion: false,
      modoEdicion: false,

      nuevoTelefono: {
        "telefonosClientesPK": {
          "telefono": "",
        },
        "activo": true,
        "borrado": false,
      },

      paisesList: [],
      vendedorList: [],
      nacionalidadList: [],
      clienteTipoList: [],
      comprobanteList: [],
      tiposPasaporte: ["Ordinario", "Diplomático",
        "Oficial/De servicio", "De emergencia", "Temporal", "Colectivo", "Electrónico/Biométrico"],
      estadosCiviles: ["Soltero/a", "Casado/a", "Divorciado/a",
        "Viudo/a", "Unión libre", "Separado/a"],

      // Data de configuracion
      windowSize: { width: "auto", height: "auto" },
      valid: true,
      BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,
      configuraciones: null,

      enEjecucion: false,

      alerta: {
        estado: false,
        color: 'success',
        message: '',
        time: 0
      },

      pasaporteListHeaders: [
        { text: 'Núm. Pasaporte', value: 'numeropasaporte', sortable: true },
        { text: 'Nombre', value: 'nombre', sortable: true },
        { text: 'Tipo', value: 'tipopasaporte' },
        { text: 'Fecha Emisión', value: 'fechaemision' },
        { text: 'Fecha Vencimiento', value: 'fechavencimiento' },
        { text: 'Nacionalidad', value: 'nacionalidad' },
        {
          text: 'Acciones',
          value: 'acciones',
          sortable: false,
          align: 'center',
          width: '120px'
        }
      ],

      // Propiedades de barra lateral
      Modallfiltro: {
        cliente: null,
        tipocliente: null,
        Clseguro: false,
        activos: true,
        opcion: 1
      },

      dialogFiltros: false,

      acti_tb_data: false,

      ObjTemTbDinam: null,
      ListItems: [],
      TbTotalItem: 0,
      TbPaginator: {
        page: 1,
        itemsPerPage: 5,
        pageStart: 1,
        pageStop: 15,
        pageCount: 10,
        itemsLength: 5,
      },

      EstadoBtn: {
        BarraTablaDinamicaAprir: false,
        nuevo: false,
        guardar: false,
        eliminar: false,
        anular: false,
        imprimir: false,
        vercuenta: false,
        guardartemporal: false,
        restaurartemporal: false,
        importarDato: false,
        cargarProducto: false,
        ImprimirproductoInv: false,
      },

      rules: {
        required: (value) => !!value || "Required.",
        greaterThanZero: (value) => value > 0 || "El valor debe ser mayor que cero",
        fechaEmisionLessThanFechaVencimiento: (value) => value <= this.pasaporte.fechavencimiento || "Fecha invalida",
        edad: [
          (val) => val > 10 || `Edad debe ser mayor a 10`,
          (val) => val < 70 || `Edad debe ser menor a 120`,
        ],
        counter: (value) =>
          (value && value.length <= 50) || "Max 20 characters",
        RTel: (value) => value != 10 || `telefono debe tener 10 digitos`,
      },
    };
  },
  computed: {
    ActDescBtn() {
      this.EstadoBtn.BarraTablaDinamicaAprir = true
      if (!this.enEjecucion) {
        this.EstadoBtn.guardar = true
        this.EstadoBtn.nuevo = true
      } else {
        this.EstadoBtn.guardar = false
        this.EstadoBtn.nuevo = false
      }
      this.windowSize = JSON.parse(
        JSON.stringify(this.$store.getters.GetwindowSize)
      );
    },
    pasaporteVencido() {
      if (this.pasaporte.fechavencimiento != null && new Date(this.pasaporte.fechavencimiento) <= new Date()) {
        return true
      }
      return false
    },
  },
};
</script>

<style>
.form-loading-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: transparent;
  padding: 20px;
  border-radius: 4px;
  z-index: 1;
}

.inline-btn {
  margin: 1rem;
  margin-top: 7px;
}
</style>